import { render, staticRenderFns } from "./SaleOrderDetail.vue?vue&type=template&id=3e74b607&scoped=true"
import script from "./SaleOrderDetail.vue?vue&type=script&lang=js"
export * from "./SaleOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderDetail.vue?vue&type=style&index=0&id=3e74b607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e74b607",
  null
  
)

export default component.exports